module.exports = __webpack_public_path__ + "media/images/themes/dark/arena-643ade6c9b18c4dc18e0d8707ad383aa.png";